export default {
  methods: {

    navigateBack(){
      return this.$router.back()
    },
    
    /**
     * Navigates "up" one level
     * Example: Given a url of "/path/to/something", this will navigate to "/path/to"
     */
    navigateUp() {
      let url = this.$route.path.split('/').slice(0, -1);
      this.$router.push({
        path: url.join('/'),
        query: { // preserve redirects
          redirect: this.$route.query.redirect,
          jump: this.$route.query.jump,
        }
      });
    },
  }
}